import { render, staticRenderFns } from "./yxform.vue?vue&type=template&id=128b04e9&scoped=true&"
import script from "./yxform.vue?vue&type=script&lang=js&"
export * from "./yxform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b04e9",
  null
  
)

export default component.exports